export class CostReviewElectricalLaborAndMaterials {
  manpowerStaffingInPlace!: number;
  travelIsRequired!: number;
  costsIncludedInEstimate!: number;
  materialPricingAndDeliveryIncluded!: number;
  siemensMaterialPricingConfirmed!: number;
  siemensMaterialDeliveryDateEstimated!: number;
  thirdPartyMaterialPricingConfirmed!: number;
  thirdPartyMaterialDeliveryDateEstimated!: number;
  workHourRequirements!: number;
  progressMeetingsRequired!: number;
  unionConsiderations!: number;
}
